module.exports = __webpack_public_path__ + "assets/img/Future_Veglio.e7903849-ps.jpg";